import { render, staticRenderFns } from "./customize_ui.vue?vue&type=template&id=b841735c&scoped=true&"
import script from "./customize_ui.vue?vue&type=script&lang=js&"
export * from "./customize_ui.vue?vue&type=script&lang=js&"
import style0 from "./customize_ui.vue?vue&type=style&index=0&id=b841735c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b841735c",
  null
  
)

export default component.exports